<template>
    <div>
        <routes-table-component
            :uuid_client="uuid_client"
            :url_get="url_get"
            :url_add="url_add"
            :url_remove="url_remove"
            :url_get_students="url_get_students"
            :url_download_report="url_download_report"
            :reload_table="reload_table"
            @setReload="recarga_tabla"
        >
        </routes-table-component>

        <route-create-custom-component
            :url_courses_wp="url_courses_wp"
            :url_get_students="url_get_students"
            :client="uuid_client"
            :url_get_companies="url_get_companies"
            :url_custom_routes="url_custom_routes"
            :url_get_route_validation="url_get_route_validation"
            @recargaTable="recarga_tabla"
        >
        </route-create-custom-component>

        <routes-default-component
            :categoryroutes="categoryroutes"
            :categorysearch="categorysearch"
            :url_suggest_routes="url_suggest_routes"
            :url_get_students="url_get_students"
            :url_get_companies="url_get_companies"
            :url_redirect="url_redirect"
            :url_get="url_get"
        >
        </routes-default-component>
    </div>
</template>

<script>
export default {
    props: [
        "uuid_client",
        "url_get",
        "url_add",
        "url_remove",
        "url_get_students",
        "url_get_companies",
        "categoryroutes",
        "categorysearch",
        "url_suggest_routes",
        "url_redirect",
        "url_courses_wp",
        "url_custom_routes",
        "url_download_report",
        "url_get_route_validation",
    ],
    data() {
        return {
            reload_table: false,
        };
    },
    mounted() {},
    methods: {
        recarga_tabla(reload) {
            this.reload_table = reload;
        },
    },
};
</script>

<style></style>
